module.exports = __webpack_public_path__ + "img/search-users.8215a35e.png";